import React, { useRef } from 'react';

const SelectField = ({
  label,
  value,
  list = [],
  onChange,
  lableKey,
  lableValue,
  disabled,
  fontsize
}) => {
  const inputRef = useRef(null);

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.style.borderColor = '#3574de';
    }
  };

  const handleBlur = () => {
    if (inputRef.current) {
      inputRef.current.style.borderColor = '#d1d5db';
    }
  };

  return (
    <div className="UI-form-group">
      <label className="UI-label" style={{fontSize:fontsize}}>{label}</label>

      <select
        ref={inputRef}
        value={value}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled}
        className={`UI-input`}  
        style={{fontSize:fontsize}}
      >
        {list.map((e, i) => (
          <option key={i} value={lableValue ? e[lableValue] : e} style={{ lineHeight: '1.8' }}>
            {lableKey ? e[lableKey] : e}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectField;